import React from "react";

export default function OneStaff({ passport, name, position, intro }) {
  return (
    <div className="col-6 col-md-3 p-3 text-center">
      {/* Staff Photo */}
      <div
        className="rounded overflow-hidden mx-auto border"
        style={{
          width: "170px",
          height: "170px",
          backgroundImage: `url(${passport})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Staff Name */}
      <h6 className="mt-3">{name}</h6>

      {/* Position / Faded background */}
      <div
        className="mx-auto mt-2"
        style={{
          background: "#f1f1f1",
          borderRadius: "8px",
          padding: "4px 8px",
          fontSize: "0.85rem",
          color: "#555",
          maxWidth: "180px",
        }}
      >
        {position}
      </div>

      {/* Short intro */}
      <p
        className="mt-2"
        style={{
          fontSize: "0.8rem",
          color: "#333",
          maxWidth: "180px",
          margin: "0 auto",
        }}
      >
        {intro}
      </p>
    </div>
  );
}
